
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import ExpertiseSection from './components/ExpertiseSection';
import ServicesSection from './components/ServicesSection';
import DifferentiatorSection from './components/DifferentiatorSection';
import CompanyDetailsSection from './components/TeamSection';
import ContactSection from './components/ContactSection';

export default function Home() {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <HeroSection />
        <ExpertiseSection />
        <ServicesSection />
        <DifferentiatorSection />
        <CompanyDetailsSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}
